// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3L-6W","danger":"styles_danger__49OHz","warning":"styles_warning__jz--R"};